function exhaustiveCheck(value: never) {
   console.error(`Value case is unhandled: ${value}`);
}

export default exhaustiveCheck;